(() => {
  const initializeMobileBuybar = (buybar) => {
    if (!buybar || buybar.dataset.initialized === 'true') return;

    const formId = buybar.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : null;
    const primarySubmit = form?.querySelector('[type="submit"][name="add"]');
    const stickySubmit = buybar.querySelector('[data-mobile-buybar-submit]');
    const stickyPrice = buybar.querySelector('[data-mobile-buybar-price]');
    const productInfo = buybar.closest('product-info');
    const priceContainer = productInfo?.querySelector('[id^="price-"]');
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    let shouldBeVisible = false;

    if (!form || !primarySubmit || !stickySubmit) return;

    buybar.dataset.initialized = 'true';

    const syncState = () => {
      const isDisabled = primarySubmit.disabled || primarySubmit.getAttribute('aria-disabled') === 'true';
      stickySubmit.disabled = isDisabled;
      stickySubmit.classList.toggle('is-loading', primarySubmit.classList.contains('loading'));

      const sourcePrice = priceContainer?.querySelector('.price-item--sale, .price-item--regular');
      if (sourcePrice && stickyPrice) stickyPrice.textContent = sourcePrice.textContent.trim();
    };

    const setVisibility = (isVisible) => {
      shouldBeVisible = isVisible;
      const showOnCurrentViewport = mobileQuery.matches && shouldBeVisible;
      buybar.classList.toggle('is-visible', showOnCurrentViewport);
      buybar.setAttribute('aria-hidden', showOnCurrentViewport ? 'false' : 'true');
      document.body.classList.toggle('mobile-buybar-visible', showOnCurrentViewport);
    };

    stickySubmit.addEventListener('click', () => {
      if (stickySubmit.disabled) return;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(primarySubmit);
      } else {
        primarySubmit.click();
      }
    });

    new MutationObserver(syncState).observe(primarySubmit, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true,
      subtree: true,
    });

    if (priceContainer) {
      new MutationObserver(syncState).observe(priceContainer, { childList: true, subtree: true });
    }

    const submitObserver = new IntersectionObserver(
      ([entry]) => setVisibility(!entry.isIntersecting),
      { threshold: 0.15 }
    );
    submitObserver.observe(primarySubmit);
    mobileQuery.addEventListener?.('change', () => setVisibility(shouldBeVisible));
    syncState();
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-mobile-buybar]').forEach(initializeMobileBuybar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('product-info:loaded', (event) => initializeAll(event.target));
})();
